import { init } from "@nosto/preact"
import { Serp, Category, Autocomplete, History } from "./components"
import { defaultConfig } from "./config"
import { closeSearchOverlay } from "../helpers"

import "./styles/index.css"


console.log("INIT SEARCH");

init({
    ...window.nostoTemplatesConfig,
    serpComponent: Serp,
    historyComponent: History,
    autocompleteComponent: Autocomplete,
    categoryComponent: Category,
    inputCssSelector: "#Search-In-Modal-1",
    contentCssSelector: "#MainContent",
    serpUrlMapping: {
        query: "q",
        "products.filter": "filter",
        "products.page": "page",
        "products.sort": "sort"
    },
    // Uncomment to redirect to search page instead of rendering on the same page
    // serpPath: '/search',
    // Uncomment to redirect to search page instead of rewriting browser history
    // serpPathRedirect: true,
    serpQuery: {
        products: {
            fields: [
                "productId", "url", "categories",
                "name", "tags1",
                "imageUrl", "alternateImageUrls",
                "brand", "availability",
                "price", "listPrice",
                "customFields.key", "customFields.value",
                "skus.name", "skus.price", "skus.listPrice",
                "skus.availability", "skus.id", "skus.imageUrl",
                "skus.customFields.key", "skus.customFields.value"
            ],
            facets: ["*"],
            size: defaultConfig.serpSize,
            from: 0
        }
    },
    autocompleteQuery: {
        products: {
            fields: [
                "productId", "url", "categories",
                "name", "tags1",
                "imageUrl", "alternateImageUrls",
                "brand", "availability",
                "price", "listPrice",
                "customFields.key", "customFields.value",
                "skus.name", "skus.price", "skus.listPrice",
                "skus.availability", "skus.id", "skus.imageUrl",
                "skus.customFields.key", "skus.customFields.value"
            ],
            size: defaultConfig.autocompleteProductsSize
        },
        keywords: {
            fields: ["keyword", "_highlight.keyword"],
            size: defaultConfig.autocompleteKeywordsSize,
            facets: ["*"]
        }
    },
    persistentSearchCache: true,
    compressUrlParameters: true,
    fallback: true,
    // // Uncomment for Category Merchandising
    categoryCssSelector: '#nosto-collection-product-grid-container',
    categoryQuery() {
        return {
            name: 'serp',
            products: {
                fields: [
                    "productId", "url", "categories",
                    "name", "tags1",
                    "imageUrl", "alternateImageUrls",
                    "brand", "availability",
                    "price", "listPrice",
                    "customFields.key", "customFields.value",
                    "skus.name", "skus.price", "skus.listPrice",
                    "skus.availability", "skus.id", "skus.imageUrl",
                    "skus.customFields.key", "skus.customFields.value"
                ],
                categoryId: this.categoryId(),
                size: defaultConfig.serpSize,
                from: 0,
            }
        }
    },
}).then(() => {
    document.getElementById('Search-In-Modal-1').addEventListener('keydown', (e) => {
        if(e.key === 'Escape' || e.key === 'Enter') {
            closeSearchOverlay();
        }
    })

    // removes native toolbar and search dropdown
    const selectorsToRemove = ['.shopify-section[id$="__filter-sort"]', '.predictive-search'];
    selectorsToRemove.forEach(selector => {
        document.querySelectorAll(selector).forEach(el => el.remove());
    })
})
